import { combineReducers } from "redux";

import session from "./session";
import reset from "./reset";
import appointments from "./appointments";
import cgn from "./cgn";
import activations from "./activations";

export default combineReducers({
  session,
  appointments,
  cgn,
  activations,
  reset,
});



// WEBPACK FOOTER //
// ./src/reducers/index.js